import { Card, Divider } from "@dash/page";
import { useTheme } from "@emotion/react";
import React from "react";
import { MdOutlineEditNote } from "react-icons/md";

import { SupportTicketMessageBody } from "./SupportTicketMessageBody";
import { SupportTicketMessageAttachments } from "./SupportTicketMessageAttachments";

import type { MessageDto } from "@megaron/support-contracts";
import type { Uuid } from "@megaron/uuid";

type Props = {
  ticketId: Uuid;
  messageId: Uuid;
  enteredByName: string;
  reporterName: string;
  reporterEmail: string;
  time: string;
  body: string;
  attachments: MessageDto["attachments"];
};

export const SupportTicketFormEntry: React.FC<Props> = ({
  ticketId,
  messageId,
  enteredByName,
  reporterName,
  reporterEmail,
  time,
  body,
  attachments,
}) => {
  const theme = useTheme();
  const trimmedReporterName = reporterName.trim();
  const trimmedReporterEmail = reporterEmail.trim();
  const reporterDisplayName = trimmedReporterName || (trimmedReporterEmail ? trimmedReporterEmail.split("@")[0] : "—");

  return (
    <Card variant="secondary" color={theme.colors.primaryLight}>
      <div css={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "0.75rem" }}>
        <div css={{ display: "flex", alignItems: "flex-start", gap: "0.625rem", minWidth: 0 }}>
          <MdOutlineEditNote
            size={16}
            css={{ color: theme.colors.primary, opacity: 0.7, flexShrink: 0, marginTop: "2px" }}
          />
          <div css={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0, fontSize: "12px", color: theme.colors.secondaryText }}>
            <span>
              Zgłaszający:{" "}
              <span css={{ fontWeight: 600, color: theme.colors.primary }}>{reporterDisplayName}</span>
              {trimmedReporterEmail ? ` · ${trimmedReporterEmail}` : null}
            </span>
            <span>
              Stworzone przez{" "}
              <span css={{ fontWeight: 600, color: theme.colors.primary }}>{enteredByName}</span>
            </span>
          </div>
        </div>
        <span css={{ fontSize: "11px", opacity: 0.55, whiteSpace: "nowrap", flexShrink: 0 }}>{time}</span>
      </div>
      <Divider />
      <SupportTicketMessageBody body={body} />
      <SupportTicketMessageAttachments ticketId={ticketId} messageId={messageId} attachments={attachments} />
    </Card>
  );
};
